module.exports = new __parcel__URL__("battleroyale_placing_button.ffb4ee46.png").toString();